export function redirectToExternalPortal(url: string) {
  window.location.replace(url);
}
